import { type FC } from 'react';
import { Navigate } from 'react-router-dom';

import { Box } from '@myphx-engineering/phx-design-system';

import { usePathwayQuestionnaire } from '../../../hooks/use-pathway-questionnaire';
import { getAbsoluteRoute } from '../../../util/get-absolute-route';

import { CoverageQuestionnaire } from './CoverageQuestionnaire';

export const CoverageSelectScreen: FC = () => {
    const questionnaire = usePathwayQuestionnaire();

    if (!questionnaire) {
        return <Navigate replace to={getAbsoluteRoute('error')} />;
    }

    return (
        <Box data-testid="coverage-questionnaire-page-root">
            <CoverageQuestionnaire
                questionnaire={questionnaire}
                testIdPrefix="coverage-questionnaire"
            />
        </Box>
    );
};
